import { useNavigate } from "react-router";
import { MainPadding } from "../../../../styles/Main.styles";
import { useState } from "react";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../../components/table/Table";
import TableHeader from "../../../../components/table/TableHeader";
import { useGetRetur } from "../../api/invoice/retur/resolver";

export default function MainRetur() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { data: dataRawRetur, isLoading: loadingFetchPaymentMethod } =
    useGetRetur({ keyword, page, perPage });
  const dataRetur = dataRawRetur?.data.data.data;
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nomor Invoice" },
    { title: "Grand Total" },
    { title: "Tanggal" },
  ];
  const body: TableFCBodyProps[] = [
    { key: "return_invoice_number" },
    { key: "grand_total", isMoney: true },
    { key: "return_invoice_date", isDate: true },
  ];

  return (
    <MainPadding>
      <TableHeader
        filterLabel="Search Invoice Retur"
        searchBar
        onSearch={(e) => setKeyword(e)}
      />
      <TableFC
        loading={loadingFetchPaymentMethod}
        data={dataRetur}
        body={body}
        showIndex
        totalRows={dataRawRetur?.data.data.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={header}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) => navigate(`/invoice/retur/${e.id}`)}
      />
    </MainPadding>
  );
}
